import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';
import {WatchGroup} from '@acng/frontend-relativity';
import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {toggle} from '@acng/frontend-bounty/style/element.js';

import {ctxAmateur} from '../../amateurPool/context/amateur.js';
import {ctxMatches} from '../context/list.js';
import {PREFIX_ACTIVE, PREFIX_INACTIVE} from '../../layout/service/style.js';
import {compile} from '../service/template.js';

/**
 * @group DOM Attribute
 */
const name = 'class-hotornot';

AttributeSetup(name, (name) => {
  const watch = WatchGroup(attributeSelector(name), ctxAmateur, ctxMatches);
  AttributeLink(name, (element) => {
    watch(element, (element, [amateur]) => {
      toggle(element, `${PREFIX_ACTIVE}match`, !!(amateur && amateur.isMatch()));
      toggle(element, `${PREFIX_INACTIVE}match`, !!(amateur && !amateur.isMatch()));
    });
  });

  return compile;
});

export {name as CLASS_HOTORNOT};
